/* Amorem — shareable symbol card. Draws a 1080x1350 card on <canvas> from a symbol's
   on-page SVG icon + text, then shares via the Web Share API (native sheet, with image
   on mobile). Falls back to download PNG + copy link on desktop. No dependencies.
   Trigger: a button with [data-amorem-share] and data-share-* attributes. */
(function () {
  if (window.__amoremShareBound) return;
  window.__amoremShareBound = true;

  var PLUM = '#6e2a63', VIOLET = '#8a3a8f', INK = '#2b2230', BODY = '#5b4f59', FOOT = '#9a7d97';
  var SANS = 'Helvetica, Arial, sans-serif', SERIF = 'Georgia, "Times New Roman", serif';

  function roundRect(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  function wrapLines(ctx, text, maxWidth, maxLines) {
    var words = (text || '').trim().split(/\s+/), line = '', lines = [];
    for (var i = 0; i < words.length; i++) {
      var test = line ? line + ' ' + words[i] : words[i];
      if (ctx.measureText(test).width > maxWidth && line) { lines.push(line); line = words[i]; }
      else line = test;
    }
    if (line) lines.push(line);
    if (maxLines && lines.length > maxLines) {
      lines = lines.slice(0, maxLines);
      lines[maxLines - 1] = lines[maxLines - 1].replace(/[\s.,;:—-]+$/, '') + '…';
    }
    return lines;
  }

  function drawLines(ctx, lines, x, y, lineHeight) {
    for (var i = 0; i < lines.length; i++) ctx.fillText(lines[i], x, y + i * lineHeight);
    return lines.length * lineHeight;
  }

  // Rasterize an on-page SVG icon (forcing a solid stroke colour, since currentColor won't resolve).
  function loadIcon(svgEl, color) {
    return new Promise(function (resolve) {
      if (!svgEl) { resolve(null); return; }
      try {
        var clone = svgEl.cloneNode(true);
        clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        clone.setAttribute('stroke', color);
        clone.setAttribute('width', '320');
        clone.setAttribute('height', '320');
        var src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(new XMLSerializer().serializeToString(clone));
        var img = new Image();
        img.onload = function () { resolve(img); };
        img.onerror = function () { resolve(null); };
        img.src = src;
      } catch (e) { resolve(null); }
    });
  }

  function drawCard(data) {
    var W = 1080, H = 1350, cx = W / 2;
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var ctx = c.getContext('2d');
    ctx.textAlign = 'center';

    // background
    var g = ctx.createLinearGradient(0, 0, W, H);
    g.addColorStop(0, '#f6eef7'); g.addColorStop(0.55, '#efe6f3'); g.addColorStop(1, '#e6daf0');
    ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);

    // inner hairline frame
    ctx.strokeStyle = 'rgba(110,42,99,.16)'; ctx.lineWidth = 2;
    roundRect(ctx, 56, 56, W - 112, H - 112, 44); ctx.stroke();

    // wordmark
    ctx.fillStyle = VIOLET; ctx.font = '700 30px ' + SANS;
    if ('letterSpacing' in ctx) ctx.letterSpacing = '8px';
    ctx.fillText('AMOREM', cx + 4, 168);
    if ('letterSpacing' in ctx) ctx.letterSpacing = '0px';

    // medallion
    ctx.beginPath(); ctx.arc(cx, 420, 135, 0, Math.PI * 2);
    ctx.fillStyle = '#ffffff'; ctx.fill();
    ctx.lineWidth = 6; ctx.strokeStyle = '#ecd9e6'; ctx.stroke();
    if (data.icon) ctx.drawImage(data.icon, cx - 90, 330, 180, 180);

    // name
    ctx.fillStyle = PLUM; ctx.font = '700 76px ' + SERIF;
    ctx.fillText(data.name || '', cx, 690);

    // meaning
    var y = 770;
    if (data.meaning) {
      ctx.fillStyle = BODY; ctx.font = '400 38px ' + SANS;
      var ml = wrapLines(ctx, data.meaning, W - 280, 5);
      y += drawLines(ctx, ml, cx, y, 56) + 26;
    }

    // affirmation
    if (data.aff) {
      ctx.fillStyle = PLUM; ctx.font = 'italic 600 42px ' + SERIF;
      var al = wrapLines(ctx, '“' + data.aff + '”', W - 300, 3);
      drawLines(ctx, al, cx, y + 10, 58);
    }

    // footer
    ctx.fillStyle = FOOT; ctx.font = '600 30px ' + SANS;
    if ('letterSpacing' in ctx) ctx.letterSpacing = '2px';
    ctx.fillText('amoremjewelry.com', cx, H - 104);
    if ('letterSpacing' in ctx) ctx.letterSpacing = '0px';

    return c;
  }

  function toast(msg) {
    if (!msg) return;
    var t = document.createElement('div');
    t.textContent = msg;
    t.setAttribute('style', 'position:fixed;left:50%;bottom:26px;transform:translateX(-50%);background:#6e2a63;color:#fff;padding:11px 18px;border-radius:24px;font:600 14px ' + SANS + ';z-index:99999;box-shadow:0 10px 30px rgba(0,0,0,.25);max-width:90vw;text-align:center;');
    document.body.appendChild(t);
    setTimeout(function () { t.style.transition = 'opacity .4s'; t.style.opacity = '0'; }, 2200);
    setTimeout(function () { t.remove(); }, 2700);
  }

  function fallback(blob, data) {
    try {
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'amorem-' + (data.key || 'symbol') + '.png';
      document.body.appendChild(a); a.click();
      setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
    } catch (e) {}
    if (navigator.clipboard && data.url) {
      navigator.clipboard.writeText(data.url).then(function () { toast(data.toast); }).catch(function () { toast(data.toast); });
    } else { toast(data.toast); }
  }

  function share(canvas, data) {
    canvas.toBlob(function (blob) {
      if (!blob) return;
      var file = new File([blob], 'amorem-' + (data.key || 'symbol') + '.png', { type: 'image/png' });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        navigator.share({ files: [file], title: data.title, text: data.text, url: data.url })
          .catch(function () {});
      } else if (navigator.share) {
        navigator.share({ title: data.title, text: data.text, url: data.url })
          .catch(function () { fallback(blob, data); });
      } else {
        fallback(blob, data);
      }
    }, 'image/png');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-amorem-share]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-disabled') === 'true') return;
    var iconSel = btn.getAttribute('data-share-icon');
    var svg = iconSel ? document.querySelector(iconSel) : null;
    var data = {
      name: btn.getAttribute('data-share-name') || '',
      meaning: btn.getAttribute('data-share-meaning') || '',
      aff: btn.getAttribute('data-share-aff') || '',
      url: btn.getAttribute('data-share-url') || location.href,
      key: btn.getAttribute('data-share-key') || 'symbol',
      title: btn.getAttribute('data-share-title') || 'Amorem',
      text: btn.getAttribute('data-share-text') || '',
      toast: btn.getAttribute('data-share-toast') || ''
    };
    btn.setAttribute('aria-disabled', 'true');
    loadIcon(svg, PLUM).then(function (icon) {
      data.icon = icon;
      share(drawCard(data), data);
      setTimeout(function () { btn.removeAttribute('aria-disabled'); }, 800);
    });
  });
})();
